const isNullishFilterValue = (value: string): boolean => {
  const normalizedValue = value.trim().toLowerCase();
  return normalizedValue === '' || normalizedValue === 'null' || normalizedValue === 'undefined';
};

export const sanitizeFilterQueryParams = (params: URLSearchParams): URLSearchParams => {
  const sanitizedParams = new URLSearchParams();

  params.forEach((value, key) => {
    if (key.startsWith('q.') && isNullishFilterValue(value)) {
      return;
    }

    sanitizedParams.append(key, value);
  });

  return sanitizedParams;
};

export const hasFilterQueryParams = (params: URLSearchParams): boolean =>
  Array.from(sanitizeFilterQueryParams(params).keys()).some((key) => key.startsWith('q.'));

export const resolveManagedDefaultFilters = <T extends object>(
  params: URLSearchParams,
  defaultFilters: T,
  clearedDefaults: Partial<T>,
): T => (
  hasFilterQueryParams(params)
    ? { ...defaultFilters, ...clearedDefaults }
    : defaultFilters
);
